<template>
  <div class="btn-control-panel" @click="clickEvent">
    <div
      :class="[
          'float-bubble',
          touching ? 'active' : '',
          isPullOver ? 'pull-over' : ''
      ]"
      :style="calcFloatStyle"
      ref="floatBubble"
      @touchstart="_touchStart"
      @touchmove.prevent.stop="_touchMove"
      @touchend="_touchEnd"
    >
     <img class="service" @click="toComponent('fb-list')"
          src="../../assets/image/yyPlatfrom/service.png" alt="">
      <!-- <i class="inner-dot"></i> -->
    </div>
  </div>
</template>

<script>
// 自动靠边动画时间
const PULL_OVER_TIME = 500
const DISTANCE_EDGE = 0
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  toRefs,
  computed,
} from 'vue'
export default defineComponent({
  name: 'dragDrop',
  props: {
    size: {
      type: Number,
      default: 56,
    },
    // 是否可以自由: true 随意移动，最终停靠在移动后的位置；false 最终会靠边儿停靠
    isFreeMove: {
      type: Boolean,
      default: true,
    },
    // 防止与iOS系统自带侧滑返回页面功能冲突，添加一个距离边界的值
    distanceToEdge: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const { proxy: ctx } = getCurrentInstance()
    const { $tool: tool, $router: router } = ctx
    const state = reactive({
      touching: false, // 是否正在移动
      isPullOver: false, // 是否添加靠边儿停靠动画
      anchor: {},
      floatStyle: {}, // 样式(位置)
      bubbleSize: ctx.size, // 浮动按钮尺寸
    })
    // 位置样式定位{ left: 0, top: 0 }
    const calcFloatStyle = computed(() => {
      return {
        left: state.floatStyle.left + 'px',
        top: state.floatStyle.top + 'px',
        height: state.bubbleSize + 'px',
        width: state.bubbleSize + 'px',
      }
    })
    const methods = {
      _getWindowSize() {
        const width =
          document.documentElement.clientWidth || document.body.clientWidth
        const height =
          document.documentElement.clientHeight || document.body.clientHeight
        return { width, height }
      },
      _touchStart(e) {
        const el = e.target // 浮标元素
        const startOffset = {
          offsetLeft: el.offsetLeft,
          offsetTop: el.offsetTop,
        }
        // console.log(el.offsetTop, el.offsetLeft)

        // 记录 touchStart (pageX, pageY, 元素位置信息)
        const firstTouch = e.touches[0]
        // console.log(firstTouch)
        const { pageX, pageY } = firstTouch
        state.anchor = {
          pageX,
          pageY,
          offsetLeft: startOffset.offsetLeft,
          offsetTop: startOffset.offsetTop,
        }
        state.touching = true
      },
      _touchMove(e) {
        const firstTouch = e.touches[0]
        // touchmove 移动差值计算
        const diffData = {
          x: (state.anchor.pageX - firstTouch.pageX) | 0,
          y: (state.anchor.pageY - firstTouch.pageY) | 0,
        }
        // 设置新的位置
        state.floatStyle = {
          left: state.anchor.offsetLeft - diffData.x,
          top: state.anchor.offsetTop - diffData.y,
        }
        ctx._insideLimit()
      },
      _touchEnd(e) {
        state.touching = false
        // 默认自动靠边显示设置, 添加动画
        if (!ctx.isFreeMove) {
          state.isPullOver = true
          const selfWidth = e.target.offsetWidth
          const bodyWidth = ctx._getWindowSize().width

          if (state.floatStyle.left < (bodyWidth - selfWidth) / 2) {
            state.floatStyle.left = ctx.distanceToEdge
          } else {
            state.floatStyle.left = bodyWidth - selfWidth - ctx.distanceToEdge
          }
        }
        // 动画完毕移除动画，防止拖动动画粘粘
        setTimeout(() => {
          state.isPullOver = false
        }, PULL_OVER_TIME)
      },
      // touchmove 限定在可视的区域内(即在 window 视口内)
      _insideLimit() {
        const el = ctx.$refs.floatBubble
        let { left, top } = state.floatStyle
        const { width: w, height: h } = ctx._getWindowSize()

        if (top < 0) top = 0
        if (top > h - el.offsetHeight) top = h - el.offsetHeight

        if (left < 0) left = 0
        if (left > w - el.offsetHeight) left = w - el.offsetHeight
        state.floatStyle = {
          left,
          top,
        }
      },
      clickEvent(e) {
        context.emit('clickHandle')
      },
    }
    onMounted(() => {
      const el = ctx.$refs.floatBubble
      state.touch = {}
      state.floatStyle = {
        left: el.offsetLeft,
        // top: el.offsetTop,
        top: 500,
      }
    })
    return { ...toRefs(state), ...methods, calcFloatStyle }
  },
})
</script>

<style lang="less" scoped>
@bubble_bg: #283740;
@bubble_size: 56px; /* 设置为一个默认样式, 但js中会重新设置覆盖此样式 */
@DISTANCE_EDGE: 0;
* {
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.btn-control-panel {
  /* 浮动按钮 */
  .float-bubble {
    position: fixed;
    left: @DISTANCE_EDGE;
    top: 50%;
    display: block;
    height: @bubble_size;
    width: @bubble_size;
    // border-radius: 20%;
    // overflow: hidden;
    // background: @bubble_bg;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 100;
    // color: #666;
    box-sizing: border-box;
    // border: 2px solid #333;
    transition: opacity 0.2s;
    z-index: 98;
    opacity: 0.5;
    &.active {
      // opacity: 0.6;
      transition: transform 0.2s;
      transform: scale(1.2);
    }

    /* 靠边停靠动画 */
    &.pull-over {
      transition: left 0.2s;
    }

    &::before,
    &::after {
      content: '';
      display: block;
      // background: #fff;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    &::before {
      width: 72%;
      height: 72%;
      // opacity: 0.4;
    }
    &::after {
      width: 56%;
      height: 56%;
      // opacity: 0.6;
    }
    .service {
      width: 152px;
      height: 150px;
    }
    .inner-dot {
      display: block;
      background: #fff;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 40%;
      height: 40%;
      opacity: 1;
    }
  }
}
</style>
